const { MONDAY_LOGO_SRC, MONDAY_LOGO_WHITE_SRC, MONDAY_WELCOME_NEW_JOINERS_LOGO_SRC, NEW_BRAND_LOGO_SRC, NEW_BRAND_LOGO_WHITE_SRC, NEW_BRAND_WELCOME_NEW_JOINERS_LOGO_SRC } = require("../constants/brand");
// Only the monday.com logo itself is replaced. Any other src — an editor's "Override Logo Image", a
// cluster or product logo (monday CRM, monday dev...) — is its own brand decision and passes through.
// CommonJS with no ESM imports, so services/brand-service.test.js runs without a transform.
const NEW_BRAND_LOGO_BY_OLD_SRC = {
    [MONDAY_LOGO_SRC]: NEW_BRAND_LOGO_SRC,
    [MONDAY_LOGO_WHITE_SRC]: NEW_BRAND_LOGO_WHITE_SRC,
    [MONDAY_WELCOME_NEW_JOINERS_LOGO_SRC]: NEW_BRAND_WELCOME_NEW_JOINERS_LOGO_SRC
};
const getBrandLogoSrc = (src, isNewBrand)=>isNewBrand && NEW_BRAND_LOGO_BY_OLD_SRC[src] || src;
module.exports = {
    MONDAY_LOGO_WHITE_SRC,
    getBrandLogoSrc
};
